<div class="content">
  <h1>{{ getClientName() }}</h1>
  <div class="flex flex-column gap-inner h-full" [ngClass]="{ spinner: isLoading() }">
    <div class="overflow-hidden pt-4">
      <p-table [value]="vesselGroups" dataKey="label" [scrollable]="true" scrollHeight="flex" [expandedRowKeys]="expandedRows">
        <ng-template pTemplate="header">
          <tr>
            <th class="w-2rem"></th>
            <th style="min-width: 8rem">Name</th>
            <th style="min-width: 6rem">IMO #</th>
            <th style="min-width: 4rem">CII Rating</th>
            <th style="min-width: 9rem">Latest M/E Overconsumption</th>
            <th style="min-width: 8rem">Manual Report Data</th>
            <th style="min-width: 8rem">Sensor Data</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-group let-expanded="expanded">
          <tr>
            <td>
              <p-button pRipple [pRowToggler]="group" [icon]="expanded ? 'albis-icons-chevron-down-2' : 'albis-icons-chevron-right-2'" />
            </td>
            <td colspan="6">{{ group.label }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-group>
          <tr *ngFor="let vessel of group.vessels">
            <td></td>
            <td>{{ vessel.label }}</td>
            <td>{{ vessel.imo }}</td>
            <td>
              <div class="inline-flex items-center gap-2">
                <span class="circle"
                      [ngStyle]="{
                    backgroundColor:
                      vessel.ciiRating === 'A'
                        ? '#9BC56D'
                        : vessel.ciiRating === 'B'
                          ? '#C6DEAB'
                          : vessel.ciiRating === 'C'
                            ? '#FDE399'
                            : vessel.ciiRating === 'D'
                              ? '#EE9DA3'
                              : vessel.ciiRating === 'E'
                                ? '#E1535D'
                                : '#E3E3E3',
                    }"></span>
                <span>{{ vessel.ciiRating || "–" }}</span>
              </div>
            </td>

            <td>
              <div class="inline-flex items-center gap-2">
                <span
                  class="circle"
                  [ngStyle]="{
                    backgroundColor:
                      !vessel.overConsumption_ratio && vessel.overConsumption_ratio !== 0
                        ? '#E3E3E3'
                        : vessel.overConsumption_ratio * 100 < 5
                          ? '#9BC56D'
                          : vessel.overConsumption_ratio * 100 < 10
                            ? '#FDE399'
                            : '#E1535D',
                  }"></span>
                <span>
                  {{ vessel.overConsumption_ratio === null ? "–" : (vessel.overConsumption_ratio * 100 | number: "1.1-1") + "%" }}
                </span>
              </div>
            </td>

            <td>
              <div class="inline-flex items-center gap-2">
                <span class="circle" [ngStyle]="{ backgroundColor: vessel.manualReportDataUpToDate ? '#9BC56D' : '#E1535D' }"></span>
                <span> {{ vessel.manualReportDataUpToDate ? "ok" : vessel.manualReportDataUtc ? (vessel.manualReportDataUtc | date:"yyyy-MM-dd hh:mm" + " UTC") : "–" }} </span>
              </div>
            </td>

            <td>
              <div class="inline-flex items-center gap-2">
                <span class="circle" [ngStyle]="{ backgroundColor: vessel.sensorDataUpToDate ? '#9BC56D' : '#E1535D' }"></span>
                <span> {{ vessel.sensorDataUpToDate ? "ok" : vessel.sensorDataUtc ? (vessel.sensorDataUtc | date:"yyyy-MM-dd hh:mm" + " UTC") : "–" }} </span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
